/**
 * @generated SignedSource<<b28a25099bcec77ec2184f0fc3e35854>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleRoutineListItemContent_Routine$data = {
  readonly description: string | null;
  readonly descriptionImages: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"AHImageStackComponent_Images">;
  }>;
  readonly id: string;
  readonly isArchived: boolean;
  readonly isOrg: boolean;
  readonly orgIconUri: string | null;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionScreenRoutineDescription_Routine">;
  readonly " $fragmentType": "TeamScheduleRoutineListItemContent_Routine";
};
export type TeamScheduleRoutineListItemContent_Routine$key = {
  readonly " $data"?: TeamScheduleRoutineListItemContent_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleRoutineListItemContent_Routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleRoutineListItemContent_Routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgIconUri",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineOccasionScreenRoutineDescription_Routine"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AHImageStackComponent_Images"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "fd22c1cf918daa27d4d967399c0f3729";

export default node;
